import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-8 pb-12 px-5 text-center" data-id="element-128">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="inline-block bg-violet-100 text-violet-800 text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-129">
        Para madres de niños de 0 a 3 años
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.08,
      ease: 'easeOut'
    }} className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-130">
        Activá el habla de tu hijo con un método paso a paso que solo requiere{' '}
        <span className="text-violet-600" data-id="element-131">10 minutos al día</span>.
      </motion.h1>

      <motion.img initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.16,
      ease: 'easeOut'
    }} src="https://cdn.magicpatterns.com/uploads/iF7Xh3DJBMXHtWtFNCGH9c/3b.png" alt="Ultrapack Activador del Habla" className="w-full h-auto object-contain mb-8" data-id="element-132" />

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.24,
      ease: 'easeOut'
    }} className="text-lg text-gray-700 leading-relaxed font-medium max-w-md mx-auto" data-id="element-133">
        El sistema más completo para ayudar a tu hijo a desarrollar el habla
        desde los 0 hasta los 3 años, con actividades simples, organizadas por
        edad y pensadas para familias argentinas.
      </motion.p>
    </section>;
}